import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SliderRangeComponent } from './slider-range.component';
import { IconsModule } from "../icons/icons.module";
import { TranslateModule } from '@ngx-translate/core';
import { ThousandsSeparatorPipe } from '../../pipes/thousands-separator.pipe';

@NgModule({
    imports: [
        CommonModule,
        IconsModule,
        TranslateModule
    ],
    exports: [
        SliderRangeComponent
    ],
    declarations: [
        SliderRangeComponent,
        ThousandsSeparatorPipe
    ],
    providers: [ThousandsSeparatorPipe],
})
export class SliderRangeModule { }
